export enum ViewModalBlock {
  Root = 'ViewModal',
}
